var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobilePayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#42455e;}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:#4da67f;}.cls-6{fill:#77cacb;}.cls-7{fill:#9fe2bf;}.cls-8{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 20,
    y1: 63,
    x2: 20,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#474f72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878c9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 20,
    y1: 59,
    x2: 20,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9dd5df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3e1f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 39,
    y1: 46,
    x2: 39,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6ab891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85cba9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 33,
    y1: 32,
    x2: 45,
    y2: 32,
    xlinkHref: "#linear-gradient-3"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mobile Payment") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile_Payment",
    "data-name": "Mobile Payment"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 1,
    width: 38,
    height: 62,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39,57v2a4,4,0,0,1-4,4H5a4,4,0,0,1-4-4V57a4,4,0,0,0,4,4H35A4,4,0,0,0,39,57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35,5V59H5V5h7a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17,4a1,1,0,0,1-2,0A1,1,0,0,1,17,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25,4a1,1,0,0,1-2,0A1,1,0,0,1,25,4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 15,
    y: 18,
    width: 48,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 15,
    y: 44,
    width: 48,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 35,
    y: 46,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 15,
    y: 46,
    width: 20,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M54,42H24a5,5,0,0,0-5-5V27a5,5,0,0,0,5-5H54a5,5,0,0,0,5,5V37A5,5,0,0,0,54,42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M60,22a1,1,0,0,1-2,0A1,1,0,0,1,60,22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M60,42a1,1,0,0,1-2,0A1,1,0,0,1,60,42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M20,22a1,1,0,0,1-2,0A1,1,0,0,1,20,22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M20,42a1,1,0,0,1-2,0A1,1,0,0,1,20,42Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 39,
    cy: 32,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M54,33H50a1,1,0,0,1,0-2h4A1,1,0,0,1,54,33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M28,33H24a1,1,0,0,1,0-2h4A1,1,0,0,1,28,33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 5,
    y: 57,
    width: 30,
    height: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePayment);
export default __webpack_public_path__ + "static/media/Mobile Payment.b750dbd7fff5c1658681784c2ddbcb1f.svg";
export { ForwardRef as ReactComponent };